// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"2878": "af3fe02c0fbe4e76","5732": "e622654c43a76988","9137": "bf7b20afaded13f7","9221": "97f5ef53c2571417",}[chunkId] + ".css"
}